import { FadeIn } from "@/components/FadeIn";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    id: "selling",
    q: "Do you sell fish, equipment, or pond construction services?",
    a: "Pond & Aquaculture Resource Centre is an independent education, training, and consulting organization. We do not provide fish, equipment, or construction services, and our recommendations are based on your property, goals, and project needs.",
  },
  {
    id: "consultation",
    q: "What happens during the free introductory consultation?",
    a: (
      <>
        The consultation is an opportunity to discuss your property, water conditions,
        <br className="hidden lg:block" /> and goals. You'll gain a better understanding of the opportunities, challenges,
        <br className="hidden lg:block" /> and possible next steps for your project.
      </>
    ),
  },
  {
    id: "who-for",
    q: "Who is pond aquaculture right for?",
    a: "Pond aquaculture is best suited for people with suitable land and water, realistic expectations, and an interest in learning. Our role is to help you understand whether it is a good fit for your property and goals.",
  },
  {
    id: "property",
    q: "Do I need a large property or an existing pond?",
    a: (
      <>
        Not necessarily. Existing ponds, dugouts, and suitable building sites all have potential — and each has trade-offs. What matters most is water quality, depth,
        <br className="hidden lg:block" /> and your goals. That's exactly what the assessment stage explores.
      </>
    ),
  },
  {
    id: "legal",
    q: "Is pond aquaculture legal in Alberta?",
    a: "Yes, with the proper licences. Alberta regulates which species can be stocked and requires a licence for private fish culture. Navigating these requirements is a core part of our education and consulting — we'll help you understand exactly what applies to\u00A0you.",
  },
  {
    id: "cost",
    q: "What do your programs and consulting cost?",
    a: "The introductory consultation is free. Program and consulting fees depend on the scope of support you need and are discussed before any work begins. We'll explain the available options during your consultation.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-background">
      {/* Narrow appendix column — deliberately the quietest, narrowest chapter */}
      <div className="mx-auto w-full max-w-[820px] px-5 sm:px-8 pt-[30px] pb-[35px] lg:pt-[60px] lg:pb-20">
        <FadeIn>
          <h2 className="font-serif-heading font-medium text-4xl sm:text-5xl lg:text-[clamp(2.25rem,2.9vw+0.5rem,3.4rem)] leading-[1.05] tracking-[-0.015em] text-foreground lg:text-center">
            Questions people ask us first
          </h2>
          <p className="mt-6 text-base leading-relaxed text-foreground/60 max-w-[52ch] lg:max-w-none lg:text-center">
            If your question isn't here, we'll answer it during your
            consultation.
          </p>
        </FadeIn>

        <FadeIn delay={0.08}>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-[18px] lg:mt-12 w-full">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                data-testid={`faq-item-${faq.id}`}
                className="border-b border-[color:var(--apn-border)]"
              >
                <AccordionTrigger className="py-7 text-left hover:no-underline group">
                  <span className="flex items-baseline gap-5">
                    <span className="font-mono-meta text-[10px] text-foreground/40 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif-heading text-lg sm:text-xl font-medium text-foreground group-hover:text-[color:var(--apn-forest)] transition-colors duration-200">
                      {faq.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-8">
                  <p className="pl-0 sm:pl-14 text-sm sm:text-base leading-[1.85] text-foreground/65 max-w-[68ch] lg:text-pretty">
                    {faq.a}
                  </p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeIn>
      </div>
    </section>
  );
};
